import { CSMLSearchLocation } from './constants';

export const getSearchLocationOptions = i18n => [
  {
    key: CSMLSearchLocation.Global,
    text: i18n.getString(_TL_('Everywhere')),
    title: i18n.getString(_TL_('Everywhere')),
  },
  {
    key: CSMLSearchLocation.Current,
    text: i18n.getString(_TL_('Current folder')),
    title: i18n.getString(_TL_('Current folder')),
  },
];
